import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import classnames from 'classnames';
import { whitelistStyles } from "../../core/hoc";
import { sizes, positions, colors } from "../../../enums";
/*
 The two divs here are required to make the use of <Panel.Takeover> easier. It is often used inside of <SidePane>
 */

var SidePane = createComponent({
  displayName: 'SidePane',
  propTypes: {
    children: PropTypes.node.isRequired,
    "float": PropTypes.oneOf(positions.LR),
    isRaised: PropTypes.bool,
    size: PropTypes.oneOf(sizes.ALL),
    color: PropTypes.oneOf([colors.DARK, colors.DARKER])
  },
  defaultProps: {
    "float": null,
    isRaised: true,
    size: sizes.X5,
    color: colors.DARK
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  render: function render(props) {
    var _classnames, _classnames2;

    var className = classnames('ck-side-pane', props.size, props.color, (_classnames = {
      inverted: props.isInverted,
      raised: props.isRaised
    }, _classnames["floated " + props["float"]] = props["float"] !== null, _classnames));
    var wrapperClassName = classnames('ck-side-pane__container', (_classnames2 = {}, _classnames2["floated " + props["float"]] = props["float"] !== null, _classnames2));
    return /*#__PURE__*/React.createElement("div", {
      className: wrapperClassName
    }, /*#__PURE__*/React.createElement("div", {
      className: className,
      style: props.style
    }, props.children));
  }
});
export default whitelistStyles()(SidePane);
//# sourceMappingURL=index.js.map